import type { ReactNode } from "react";

/** Низ формы в окне: подсказка слева, «Отмена» и главное действие справа. */
export function DialogFooter({ children }: { children: ReactNode }) {
  return <div className="flex items-center justify-end gap-2 border-t border-border px-4 py-2.5">{children}</div>;
}
